import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { getClientDetails } from '../../utils/api/client';

const initialState = {
    details: null
};

const slice = createSlice({
    name: 'client',
    initialState,
    reducers: {
        setClientDetails(state, action) {
            state.details = action.payload;
        }
    }
});

export default slice.reducer;

/**
 * submit learner form
 * updates the learner details
 */
export function fetchClient(params) {
	return async () => {
		try {
            const { data } = await getClientDetails();
			dispatch(slice.actions.setClientDetails(data?.data));
			return data?.data || null;
		} catch (err) {
			console.log(err);
			return null; // Return null on error to prevent undefined
		}
	};
}